<template>
    <search-layout
        v-if="loaded"
        :map-expanded="mapExpanded"
        :offers-count="searchResponse.product.length"
        :search-active="searchActive"
    >
        <template v-slot:breadcrumbs>
            <expired-offers-snackbar :is-offers-expired="isOffersExpired" @refresh="search" />
            <transfer-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:left-sidebar>
            <transfer-search-summary :search-request="searchRequest" />
            <sort-select v-model="sortKey" :items="sortItems" />
            <transfer-filters
                :filter-values="filterValues"
                :filters="searchResponse.filters"
                :filtered-offers-count="filteredOffers.length"
                :currency="currency"
                @change="changeFilter"
                @reset="resetFilters"
            />
        </template>
        <template v-slot:main-content>
            <search-progress
                :filtered-offers-count="filteredOffers.length"
                :total-offers-count="searchResponse.product.length"
                :search-active="searchActive"
                @stop="stopSearch"
            />
            <transfer-offers :offers="offers" />
            <pagination v-model="page" :pages="pages" />
            <transfer-info-modal />
        </template>
        <template v-slot:right-sidebar>
            <client-only>
                <transfer-map v-model="mapExpanded" :points="mapPoints" />
            </client-only>
        </template>
    </search-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import MobileSearchPageTabs from '@/components/snippets/MobileSearchPageTabs.vue'
    import Pagination from '@/components/search/Pagination.vue'
    import TransferBreadcrumbs from '@/components/transfers/TransferBreadcrumbs.vue'
    import TransferOffers from '@/components/transfers/search/offers/TransferOffers.vue'
    import TransferFilters from '@/components/transfers/search/TransferFilters.vue'
    import TransferSearchSummary from '@/components/transfers/search/TransferSearchSummary.vue'
    import TransferMap from '@/components/transfers/search/TransferMap.vue'
    import TransferInfoModal from '@/components/transfers/info/TransferInfoModal.vue'
    import {SearchPageBase} from '@/mixins/SearchPageBase.vue'
    import {TransferPageMixin} from '@/components/transfers/mixins/TransferPageMixin.vue'
    import ExpiredOffersSnackbar from '@/components/search/ExpiredOffersSnackbar.vue'
    import SearchProgress from '~src/components/search/searchProgress.src'
    import {TransferStoreMixin} from '@/mixins/TransferStoreMixin.vue'
    import SortSelect from '@/components/search/SortSelect.vue'
    import {SearchPageMixin} from '@/components/mixins/SearchPageMixin.vue'
    import {Tmp_SearchPageBase} from '@/mixins/Tmp_SearchPageBase.vue'
    import SearchLayout from '~src/components/parts/searchLayout.src'
    import {useTransferRuntimeData} from '~/composables/transfer'

    @Component({
        components: {
            SortSelect,
            SearchProgress,
            ExpiredOffersSnackbar,
            TransferOffers,
            Pagination,
            MobileSearchPageTabs,
            TransferBreadcrumbs,
            TransferFilters,
            TransferSearchSummary,
            TransferMap,
            TransferInfoModal,
            SearchLayout,
        },
        async setup() {
            const route = useRoute()
            const {
                arrivalHotelCode,
                arrivalPlace,
                arrivalCityId,
                arrivalPlaceId,
                departureHotelCode,
                departurePlace,
                departureCityId,
                departurePlaceId,
            } = route.query
            const queryKey = new URLSearchParams({
                arrivalHotelCode,
                arrivalPlace,
                arrivalCityId,
                arrivalPlaceId,
                departureHotelCode,
                departurePlace,
                departureCityId,
                departurePlaceId,
            })
            await useAsyncData(`transfer-${queryKey}`, async () => {
                await useTransferRuntimeData(route)
                return true
            })
        },
    })
    export class TransfersPage extends mixins(
        SearchPageBase,
        Tmp_SearchPageBase,
        TransferPageMixin,
        TransferStoreMixin,
        SearchPageMixin
    ) {
        async fetch() {
            await this.loadRuntimeData()
        }

        get mapPoints() {
            return [transfersRuntimeStore.departurePoint, transfersRuntimeStore.arrivalPoint]
        }
    }

    export default TransfersPage
</script>
